import { css, type Theme } from "@emotion/react";
import styled from "@emotion/styled";

import { FONT_WEIGHT_SEMI_BOLD } from "@skilitics/designer-ui-components";

// Refined-minimal sidebar layout scale. Kept in one place so every section
// shares the same rhythm, radii and interaction states.
export const SIDEBAR_WIDTH = 264;
export const SIDEBAR_PADDING = 25;
export const SIDEBAR_WIDTH_WIDE = 320;
export const SIDEBAR_WIDE_BREAKPOINT = 1600;
export const SIDEBAR_INLINE_PADDING = 10;
export const SIDEBAR_ITEM_RADIUS = 8;

// Hairline separator between sidebar groups.
export const SidebarDivider = styled.div`
  height: 1px;
  margin: 0 ${SIDEBAR_INLINE_PADDING}px;
  background: ${({ theme }) => theme.outlineSoft};
`;

// Shared interactive row used by nav links, the support link, the workspace
// switcher and the user menu trigger: flat by default, soft surface on hover,
// quiet pill when selected.
export const sidebarItemCss = ({ theme }: { theme: Theme }) => css`
  display: flex;
  align-items: center;
  gap: 10px;

  padding: 9px ${SIDEBAR_INLINE_PADDING}px;
  border-radius: ${SIDEBAR_ITEM_RADIUS}px;

  color: ${theme.generalTextIcon};
  font-size: 14px;
  font-weight: ${FONT_WEIGHT_SEMI_BOLD};
  text-decoration: none;
  user-select: none;
  white-space: nowrap;

  cursor: pointer;
  transition:
    background-color 150ms ease,
    color 150ms ease;

  &:hover {
    background: ${theme.surfaceHighlight};
  }

  &.active,
  &.pending {
    background: ${theme.primaryContainer};
    color: ${theme.primaryStrong};
  }
`;
